module.exports = __webpack_public_path__ + "static/img/technology-3.84c5545e.png";